// packages/world-model/src/traits/identity/index.ts

export * from './identityTrait';
export * from './identityBehavior';